import { Modal } from "react-bootstrap";

import "./deleteConfirmation.css";

export default function DeleteConfirmation({
  deletePopup,
  cancelDelete,
  confirmDelete,
}: any) {
  if (deletePopup.showPopup) {
    return (
      <>
        <Modal
          show={deletePopup.showPopup}
          onHide={() => {
            cancelDelete();
          }}
          backdrop="static"
          dialogClassName="deletemodal-200w"
          size="lg"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
          backdropClassName="backdrop2"
        >
          <Modal.Header closeButton>
            <Modal.Title className="headingFont"
              style={{
                color: "#495057"                
              }}
            >
              Confirm Delete
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="f-12">{deletePopup.popupMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="buttonCss"
              onClick={() => {
                cancelDelete();
              }}
            >
              Cancel
            </button>
            <button
              className="buttonCss"
              onClick={(e) => {
                e.preventDefault();
                confirmDelete();
              }}
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
}
